import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import {
  type GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetData,
  type GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetError,
  type GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetResponse,
  getIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGet,
} from '../../generated';

export type GetIdeaQueryVariables = GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetData['path'];

export type GetIdeaQuery = GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetResponse;

export const useGetIdeaQuery = <
  TData = GetIdeaQuery,
  TError = GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetError,
>(
  { portfolio_id, image_id, idea_id }: GetIdeaQueryVariables,
  options?: Omit<UseQueryOptions<GetIdeaQuery, TError, TData>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery<GetIdeaQuery, TError, TData>({
    queryKey: ['GetIdea', { portfolio_id, image_id, idea_id }],
    queryFn: async () => {
      const { data } = await getIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGet({
        path: { portfolio_id, image_id, idea_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useGetIdeaQuery.getKey = ({ portfolio_id, image_id, idea_id }: GetIdeaQueryVariables) => [
  'GetIdea',
  { portfolio_id, image_id, idea_id },
];

useGetIdeaQuery.fetcher = (
  { portfolio_id, image_id, idea_id }: GetIdeaQueryVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await getIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGet({
      path: { portfolio_id, image_id, idea_id },
      throwOnError: true,
    });
    return data;
  };
};
